import React from 'react';
import { Form } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { setAssistantsToCompany } from '../../../../redux/customers/customersActions';
import AIAssistantsFromInner from './AIAssistantsFromInner';

function AIAssistantsFrom() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const companyAssistants = useSelector((state) => state.customers.customerInfo?.assistants);

  const initialValues = {
    assignedAssistants: companyAssistants ?? [],
  };

  const handleChangeAssistants = async (values) => {
    await dispatch(setAssistantsToCompany({ assistants: values.assignedAssistants, companyId: id }));
  };

  return (
    <Form
      initialValues={initialValues}
      onSubmit={handleChangeAssistants}
      subscription={{
        submitting: true,
        submitFailed: true,
        submitSucceeded: true,
      }}
      render={({ handleSubmit }) => <AIAssistantsFromInner onSubmit={handleSubmit} />}
    />
  );
}

export default AIAssistantsFrom;
